export enum EventStatus {
  approved = 'approved',
  rejected = 'rejected',
  approved_warning = 'approved_warning',
}
